import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "reactstrap";
import { findAllVeloxityAudience } from "../../../slices/veloxity/audience/FindAllAudienceReducer";
import { getAllTargetAudience } from "../../../slices/veloxity/targetAudience/getAllTargetAudience";
import { fetchConfigsByType } from "../../../slices/veloxity/integration/fetchConfigsSlice";
import { getExportPlans } from "../../../slices/veloxity/integration/export/getExportPlans";
import AdButtonGroup from "./AdButtonGroup";
import AdFormModal from "./ThirdPartyPlatforms/NewAdvertisement/AdFormModal";
import MetaAdModal from "./ThirdPartyPlatforms/NewAdvertisement/MetaAdModal";
import GoogleAdModal from "./ThirdPartyPlatforms/NewAdvertisement/GoogleAdModal";
import CreateTiktokAdModal from "./ThirdPartyPlatforms/NewAdvertisement/CreateTiktokAdModal";
import AdsTable from "./ThirdPartyPlatforms/NewAdvertisement/AdsTable";
import BreadCrumb from "../../../components/common/BreadCrumb";

function CustomerGrowth() {
    const [selectedButton, setSelectedButton] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useDispatch();

    const exportPlans = useSelector((state) => state.getExportPlans.data);
    const exportPlansLoading = useSelector((state) => state.getExportPlans.loading);
    const exportPlansError = useSelector((state) => state.getExportPlans.error);

    const toggleModal = () => {
        setIsModalOpen((prevState) => {
            const nextState = !prevState;

            if (nextState) {
                dispatch(findAllVeloxityAudience());
                dispatch(getAllTargetAudience());
                if (selectedButton !== null) {
                    const typeMap = {
                        0: "ADFORM_S3",
                        1: "GOOGLE",
                        2: "FACEBOOK",
                        3: "TIKTOK",
                    };
                    dispatch(fetchConfigsByType(typeMap[selectedButton]));
                }
            }

            return nextState;
        });
    };

    useEffect(() => {
        dispatch(getExportPlans());
    }, [dispatch]);

    const typeMap = {
        0: "DMP_EXPORT_TO_S3",
        1: "DSP_EXPORT_GOOGLE_ADS",
        2: "DSP_EXPORT_FACEBOOK",
        3: "DSP_EXPORT_TIKTOK_ADS",
    };

    const filteredExportPlans =
        exportPlans && selectedButton !== null
            ? exportPlans.filter((plan) => plan.exportType === typeMap[selectedButton])
            : exportPlans;

    const getLabels = (selectedButton) => {
        switch (selectedButton) {
            case 0:
                return { newButtonLabel: "New AdForm Ad", modalTitle: "Add New AdForm Ad" };
            case 1:
                return { newButtonLabel: "New Google Ad", modalTitle: "Add New Google Ad" };
            case 2:
                return { newButtonLabel: "New Meta Ad", modalTitle: "Add New Meta Ad" };
            case 3:
                return { newButtonLabel: "New TikTok Ad", modalTitle: "Add New TikTok Ad" };
            case 4:
                return { newButtonLabel: "New LinkedIn Ad", modalTitle: "Add New LinkedIn Ad" };
            case 5:
                return { newButtonLabel: "New Amazon Ad", modalTitle: "Add New Amazon Ad" };
            default:
                return { newButtonLabel: "New Ad", modalTitle: "Add New Ad" };
        }
    };

    const { newButtonLabel, modalTitle } = getLabels(selectedButton);

    document.title = "AIMEE - Customer Growth";


    const renderModal = () => {
        if (selectedButton === 0) {
            // AdFormS3 Modal
            return (
                <AdFormModal
                    newButtonLabel={newButtonLabel}
                    modalTitle={modalTitle}
                    isModalOpen={isModalOpen}
                    toggleModal={toggleModal}
                    selectedButton={selectedButton}
                />
            );
        } else if (selectedButton === 1) {
            // GoogleAd Modal
            return (
                <GoogleAdModal
                    newButtonLabel={newButtonLabel}
                    modalTitle={modalTitle}
                    isModalOpen={isModalOpen}
                    toggleModal={toggleModal}
                    selectedButton={selectedButton}
                />
            );
        } else if (selectedButton === 2) {
            // MetaAd Modal
            return (
                <MetaAdModal
                    newButtonLabel={newButtonLabel}
                    modalTitle={modalTitle}
                    isModalOpen={isModalOpen}
                    toggleModal={toggleModal}
                    selectedButton={selectedButton}
                />
            );
        } else if (selectedButton === 3) {
            // TikTokAd Modal
            return (
                <CreateTiktokAdModal
                    newButtonLabel={newButtonLabel}
                    modalTitle={modalTitle}
                    isOpen={isModalOpen}
                    toggle={toggleModal}
                    selectedButton={selectedButton}
                />
            );
        }
        return null;
    };

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Advertisement Management" pageTitle="3rd Party Platforms" />

                    <AdButtonGroup onButtonSelect={setSelectedButton} selectedButton={selectedButton} />

                    <AdsTable
                        newButtonLabel={newButtonLabel}
                        toggleModal={toggleModal}
                        exportPlans={filteredExportPlans}
                        loading={exportPlansLoading}
                        error={exportPlansError}
                    />

                    {renderModal()}
                </Container>
            </div>
        </>
    );
}

export default CustomerGrowth;
